import { Link } from "react-router-dom";

const columns = [
  {
    title: "深度栏目",
    links: [
      { label: "商业起底", to: "/topics?category=business" },
      { label: "行业内幕", to: "/topics?category=industry" },
      { label: "舆情深挖", to: "/topics?category=opinion" },
      { label: "全部专题", to: "/topics" },
    ],
  },
  {
    title: "专区导航",
    links: [
      { label: "最新归档", to: "/topics" },
      { label: "热门榜单", to: "/topics?sort=hot" },
      { label: "关于我们", to: "/about" },
      { label: "常见问题", to: "/about#faq" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-20 bg-secondary-950 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-file-search-line text-xl" />
              </span>
              <span className="font-heading text-xl font-bold tracking-wide">看料档案</span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-7 text-background-300">
              我们不做最快的转载，只做最完整的梳理。把散落的信息重新拼回逻辑链条，让每一次公共事件的来龙去脉都留下可查阅的档案。
            </p>
            <div className="mt-6 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-background-700 text-background-200">
                <i className="ri-mail-line" />
              </span>
              <span className="text-sm text-background-300">contact@kanliao-archive.example</span>
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-base font-semibold text-background-50">
                <span>{col.title}</span>
              </h4>
              <ul className="mt-5 flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="whitespace-nowrap text-sm text-background-300 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} 看料档案 · 内容仅供阅读与信息梳理参考
          </p>
          <div className="flex items-center gap-4 text-sm text-background-300">
            <span className="whitespace-nowrap">深挖事件 · 起底背后</span>
          </div>
        </div>
      </div>
    </footer>
  );
}